import React from 'react';
import { cn } from '@/lib/utils';
import { HeatLevel } from '../hooks/usePostHeatLevel';

interface PostGlowWrapperProps {
  heatLevel: HeatLevel;
  children: React.ReactNode;
  className?: string;
}

export function PostGlowWrapper({ heatLevel, children, className }: PostGlowWrapperProps) {
  if (heatLevel.level === 0) {
    return <>{children}</>;
  }
  
  return (
    <div className={cn(
      "relative rounded-lg overflow-hidden",
      // Level 1: Warming - subtle warm border
      heatLevel.level === 1 && [
        "ring-2 ring-amber-400/50",
        "shadow-[0_0_10px_rgba(251,191,36,0.2)]",
      ],
      // Level 2: Hot - orange glow
      heatLevel.level === 2 && [
        "ring-2 ring-orange-500/70",
        "shadow-[0_0_15px_rgba(249,115,22,0.4)]",
      ],
      // Level 3: Fire - red animated glow
      heatLevel.level === 3 && [
        "ring-2 ring-red-500/80",
        "shadow-[0_0_20px_rgba(239,68,68,0.5)]",
        "animate-[pulse-glow_2s_ease-in-out_infinite]",
      ],
      // Level 4: Viral - rainbow animated glow
      heatLevel.level === 4 && [
        "ring-[3px] ring-transparent",
        "bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 p-[2px]",
        "shadow-[0_0_25px_rgba(168,85,247,0.6)]",
        "animate-[rainbow-pulse_3s_ease-in-out_infinite]",
      ],
      className
    )}>
      {/* Inner content wrapper for viral level to show gradient border */}
      {heatLevel.level === 4 ? (
        <div className="bg-card rounded-lg">
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
